import { Link } from 'react-router-dom';

const audiences = [
  { icon: 'ri-user-add-line', title: 'Новые сотрудники', desc: 'Помощь в адаптации, освоении стандартов и выходе на самостоятельную работу.' },
  { icon: 'ri-user-star-line', title: 'Перспективные сотрудники', desc: 'Развитие компетенций и подготовка к более сложным задачам.' },
  { icon: 'ri-vip-crown-line', title: 'Потенциальные руководители', desc: 'Формирование управленческих навыков и подготовка кадрового резерва.' },
  { icon: 'ri-arrow-left-right-line', title: 'Сотрудники, меняющие роль', desc: 'Поддержка при переходе на новую должность или расширении зоны ответственности.' },
  { icon: 'ri-award-line', title: 'Сильные специалисты', desc: 'Передача экспертизы другим сотрудникам и подготовка внутренних экспертов.' },
];

export default function WhoToDevelop() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Кого и чему развивать
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Наставничество решает задачи разных категорий сотрудников — от новых до сильных специалистов, которых готовят к будущим ролям
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {audiences.map((a) => (
            <div key={a.title} className="bg-white rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors">
              <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center mb-4">
                <i className={`${a.icon} text-teal-700 text-lg`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-2">{a.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{a.desc}</p>
            </div>
          ))}
        </div>

        <p className="text-center text-sm text-gray-500 mt-10 max-w-3xl mx-auto leading-relaxed">
          Наставничество новых сотрудников пересекается с их адаптацией. Подробнее о вводе новых людей в должность — на странице{' '}
          <Link to="/enciklopediya-korporativnogo-obucheniya/adaptaciya-sotrudnikov" className="text-teal-600 hover:text-teal-700 font-semibold cursor-pointer">
            «Адаптация сотрудников»
          </Link>.
        </p>
      </div>
    </section>
  );
}